const actions = {
    async identidyInputAction(context, params) {
        try {
            context.commit('identidyInputMutation', params);
        } catch (error) {
            console.log(error);
        }
    },
};

export default actions;